import { LOGIN, LOGOUT } from "./Types";
import axios from "axios";
import { API_URL } from "../config";
import { ErrorHandler } from "../Helpers/ErrorHandler";
import { notification } from 'antd';

export const Login_ = (login_Req_Data) => async dispatch => {
    try {
        const login_Res_Data = await axios.post(API_URL + 'login', login_Req_Data);
        const { message, success, data } = login_Res_Data.data;
        if (success) {
            const localStorage_Data = {
                Token: data.Token,
                email: data.email,
                name: data.firstName + ' ' + data.lastName,
                role: data.Roles[0].role,
                isAuthenticated: true
            }
            dispatch({ type: LOGIN, payload: localStorage_Data })
            await notification['success']({
                message: 'Success..',
                description: message,
            });
            return true;
        } else {
            return false;
        }
    } catch (error) {
        await ErrorHandler(error);
        return false
    }
}

export const logout = () => dispatch => {
    dispatch({ type: LOGOUT });
    window.location.reload();
    return true;
};